export class StringHelper {

  /**
   * Applies the standard String.trim functionality but also trims given characters.
   * @param {string} text
   * @param {string} char character to trim
   * @returns {string}
   */
  public static trim(text: string, char = '\\s'): string {
    return text.replace(new RegExp(`^[${char}]*|[${char}]*$`, 'g'), '');
  }
}

